import { grey } from '@mui/material/colors';
import { withStyles, WithStyles } from "@mui/styles";
import { DashBoxStyles } from "components/Dashboard/DashBoxStyles";
import * as React from "react";
import { Doughnut } from "react-chartjs-2";


export interface DashDoughnutProps {
    value: number;
    color: string;
    nullText?: string;
}

type Props = DashDoughnutProps & WithStyles<typeof DashBoxStyles>;

export const DoughnutCenterText = {
    id: "DoughnutCenterText",
    beforeDraw: function (chart: any, args: any, options: any) {
        if (chart.config.data
            && chart.config.data.datasets
            && chart.config.data.datasets.length > 0 
            && chart.config.data.datasets[0].options 
            && chart.config.data.datasets[0].options.elements
            && chart.config.data.datasets[0].options.elements.center) {

            //Get ctx from string
            var ctx = chart.ctx;

            //Get options from the center object in options
            var centerConfig = chart.config.data.datasets[0].options.elements.center;
            var fontStyle = centerConfig.fontStyle || 'Arial';
            var txt = centerConfig.text;
            var color = centerConfig.color || '#000';
            var sidePadding = centerConfig.sidePadding || 20;
            var sidePaddingCalculated = (sidePadding / 100) * (chart.innerRadius * 2);
            //Start with a base font of 30px
            ctx.font = "20px " + fontStyle;

            //Get the width of the string and also the width of the element minus 10 to give it 5px side padding
            var stringWidth = ctx.measureText(txt).width;
            var elementWidth = (chart.innerRadius * 2) - sidePaddingCalculated;

            // Find out how much the font can grow in width.
            var widthRatio = elementWidth / stringWidth;
            var newFontSize = Math.floor(30 * widthRatio);
            var elementHeight = (chart.innerRadius * 2);

            // Pick a new font size so it will not be larger than the height of label.
            var fontSizeToUse = Math.min(newFontSize, elementHeight);

            //Set font settings to draw it correctly.
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            var centerX = ((chart.chartArea.left + chart.chartArea.right) / 2);
            var centerY = ((chart.chartArea.top + chart.chartArea.bottom) / 2);
            ctx.font = fontSizeToUse + "px " + fontStyle;
            ctx.fillStyle = color;

            //Draw text in center
            ctx.fillText(txt, centerX, centerY);
        }
    }
};

const DashDoughnut: React.FC<Props> = (props) => {

    const { value, color, nullText } = props;

    const v = Math.round(value);

    const chartData = {
        datasets: [{
            data: [v, 100 - v],
            backgroundColor: [
                color,
                grey[500]
            ],
            options: {
                elements: {
                    center: {
                        text: value == null ? (nullText || "N/D") : `${v.toFixed(0)}%`,
                        color: grey.A200,
                        fontStyle: 'Arial',
                        sidePadding: 20
                    }
                }
            }
        }]
    };

    return <Doughnut
        data={chartData}
        options={
            {
                responsive: false,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        enabled: false
                    }
                }
            }
        }
        plugins={
            [
                DoughnutCenterText
            ]
        }
    />;
};

export default withStyles(DashBoxStyles)(DashDoughnut);
